import { match } from 'react-router';
import { replaceLocationPathName } from '@core/utils/methods';

export const isExistsRoute = (
  routes: string[],
  path: string,
  { params }: Partial<match>,
): boolean => {
  const currentRoute = replaceLocationPathName(path, params);

  return routes.includes(currentRoute);
};
